var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "75px",
    viewBox: "0 0 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Universal_McCann_logo 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "landing-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pursway",
    transform: "translate(-1027.000000, -321.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(225.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38-Copy",
    transform: "translate(0.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universal_McCann_logo-1",
    transform: "translate(802.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5002849,0 C16.7895616,0 0,16.7913499 0,37.500536 C0,58.2103742 16.7895616,75 37.5002849,75 C58.2126359,75 75,58.2103742 75,37.500536 C75,16.7913499 58.2126359,0 37.5002849,0 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3160467,25.0435407 C28.3633327,24.818541 28.5894268,24.6326717 28.8193461,24.6326717 L35.0720115,24.6326717 C35.3024192,24.6326717 35.4540438,24.818541 35.4122107,25.0435407 L32.5529913,38.6533335 C30.8209055,46.819682 25.4133664,50.3962808 18.2503833,50.3962808 C13.6493116,50.3962808 7.36184495,46.7473723 9.04392639,38.8348822 L11.8819037,25.0457418 C11.9308175,24.8180519 12.1536561,24.6326717 12.3862612,24.6326717 L18.6389266,24.6326717 C18.8704736,24.6326717 19.0215286,24.8180519 18.9748122,25.0457418 L16.1671924,38.689203 C15.3905942,42.3381115 16.8584967,44.0718321 19.6671745,44.0718321 C22.4764221,44.0718321 24.6611844,42.411481 25.4176799,38.8696919 L28.3160467,25.0435407 Z M39.187689,25.0430516 C39.2388003,24.8180519 39.4643247,24.6326717 39.695302,24.6326717 L46.236567,24.6326717 C46.4697418,24.6326717 46.7289606,24.8103888 46.810999,25.0229157 L50.4321669,34.0359479 C50.5164028,34.2490455 50.7071748,34.2794531 50.8522884,34.1027957 L58.4130929,24.9544376 C58.559346,24.777291 58.8691063,24.6326717 59.1011417,24.6326717 L65.6386629,24.6326717 C65.871268,24.6326717 66.0217532,24.8180519 65.9712117,25.0430516 L60.7685246,49.5164177 C60.7218082,49.7419881 60.4940864,49.9272868 60.2641671,49.9272868 L54.1549876,49.9272868 C53.925638,49.9272868 53.7751528,49.7419881 53.8234969,49.5164177 L56.7365133,35.8104294 C56.7837994,35.5854297 56.6979357,35.5424678 56.5511943,35.7185545 L48.5495958,44.9838147 C48.3995989,45.1577003 48.242033,45.3017491 48.2034554,45.3017491 C48.1637383,45.3017491 48.0561443,45.1289232 47.9605141,44.9158256 L43.9811605,35.8560815 C43.8871581,35.6463264 43.773053,35.6577394 43.727883,35.8832282 L40.8290279,49.5164177 C40.7789747,49.7419881 40.5518226,49.9272868 40.321415,49.9272868 L34.3176321,49.9272868 C34.0910497,49.9272868 33.9404831,49.7419881 33.9866297,49.5164177 L39.187689,25.0430516 Z",
    id: "Shape",
    fill: "#1D23BF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUm);
export default __webpack_public_path__ + "static/media/um.0db6f8f36eb67fb51393a8544e5bafaf.svg";
export { ForwardRef as ReactComponent };